(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momentum-testimonials"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('momentum-patient-stories')) {
  customElements.define('momentum-patient-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.mcReady) return;
      this.mcReady = true;
      this.mcEvents = new AbortController();
      const options = { signal: this.mcEvents.signal };
      const videos = Array.from(this.querySelectorAll('video'));
      const status = this.querySelector('.mc-status');
      const storiesContainer = this.querySelector('.mc-stories');
      const prevBtn = this.querySelector('.mc-nav-prev');
      const nextBtn = this.querySelector('.mc-nav-next');
      
      // Arrow Navigation Logic
      if (storiesContainer && prevBtn && nextBtn) {
        const updateArrows = () => {
          const maxScroll = storiesContainer.scrollWidth - storiesContainer.clientWidth;
          
          if (maxScroll <= 0) {
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
          } else {
            prevBtn.style.display = '';
            nextBtn.style.display = '';
            prevBtn.disabled = storiesContainer.scrollLeft <= 5;
            nextBtn.disabled = storiesContainer.scrollLeft >= maxScroll - 5;
          }
        };

        const scrollByCard = (direction) => {
          const card = storiesContainer.querySelector('.mc-story');
          if (card) {
            const scrollAmount = (card.offsetWidth + 20) * direction;
            storiesContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
          }
        };

        prevBtn.addEventListener('click', () => scrollByCard(-1), options);
        nextBtn.addEventListener('click', () => scrollByCard(1), options);
        
        storiesContainer.addEventListener('scroll', updateArrows, { ...options, passive: true });
        window.addEventListener('resize', updateArrows, { ...options, passive: true });
        
        setTimeout(updateArrows, 100);
      }

      // Video Logic
      const playVideo = (video) => {
        status.textContent = '';
        const attempt = video.play();
        if (attempt) attempt.catch(() => {
          status.textContent = 'The video could not start. Please try the player controls.';
        });
      };
      
      videos.forEach((video) => {
        const thumbnail = video.closest('.mc-thumbnail');
        const overlay = thumbnail.querySelector('.mc-play');
        const duration = thumbnail.querySelector('.mc-time');
        if (overlay) {
          overlay.hidden = false;
          overlay.addEventListener('click', () => playVideo(video), options);
        }
        video.addEventListener('play', () => {
          videos.forEach((other) => { if (other !== video) other.pause(); });
          if (overlay) {
            if (document.activeElement === overlay) video.focus({ preventScroll: true });
            overlay.hidden = true;
          }
          if (duration) duration.hidden = true;
          status.textContent = '';
        }, options);
        video.addEventListener('loadedmetadata', () => {
          if (duration && Number.isFinite(video.duration)) {
            const seconds = Math.floor(video.duration);
            duration.textContent = Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
            duration.hidden = !video.paused;
          }
        }, options);
        video.addEventListener('error', () => {
          status.textContent = 'This video is unavailable. Please try another patient story.';
        }, options);
      });
      
      this.querySelector('.mc-watch')?.addEventListener('click', (event) => {
        const firstVideo = videos[0];
        if (!firstVideo) return;
        event.preventDefault();
        storiesContainer.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          block: 'start'
        });
        firstVideo.focus({ preventScroll: true });
        playVideo(firstVideo);
      }, options);
    }
    
    disconnectedCallback() {
      this.mcEvents?.abort();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.mcReady = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
